export enum FileKind {
    FULL_TIME_EDUCATION = "FULL_TIME_EDUCATION",
    MEDICAL = "MEDICAL",
    KRA = "KRA",
    PASSPORT = "PASSPORT",
    NATIONAL_ID = "NATIONAL_ID"
}